import * as Sentry from '@sentry/react';

import config from './config';

Sentry.init({
  dsn: 'https://021dc415d08fb99053cd0bc79a8d7ac5@o4506733056688128.ingest.sentry.io/4506733441253377',
  release: 'jpu-admin@' + process.env.REACT_APP_VERSION,
  environment: config.ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/us-central1-jigsaw-puzzle-universe-web\.cloudfunctions\.net/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
